module.exports = __webpack_public_path__ + "img/application.ccf024de.svg";